import * as Api from '@ViewModels';
import { type ReactNode, useMemo, useState } from 'react';
import {
	EditAutomationTemplateStepsContext,
	type IEditAutomationTemplateStepsContext,
} from '../../../models/Automations';

interface AutomationCanvasEditorStepsProviderProps {
	templateId?: string;
	impersonationContext?: Api.IImpersonationContext;
	children: ReactNode;
}

/**
 * Provides the legacy automation editor steps context to the canvas editor.
 *
 * The trigger configuration UI reuses legacy components that still read edit
 * permissions from useAutomationEditorContext(), which depends on this provider.
 */
export function AutomationCanvasEditorStepsProvider({
	templateId,
	impersonationContext,
	children,
}: AutomationCanvasEditorStepsProviderProps) {
	const [unsavedStep, setUnsavedStep] = useState<Api.IAutomationStep>(null);

	const contextValue = useMemo<IEditAutomationTemplateStepsContext>(() => {
		return {
			automationTemplateId: templateId || undefined,
			impersonationContext,
			unsavedStep,
			setUnsavedStep,
		};
	}, [templateId, impersonationContext, unsavedStep]);

	return (
		<EditAutomationTemplateStepsContext.Provider value={contextValue}>
			{children}
		</EditAutomationTemplateStepsContext.Provider>
	);
}
